import { useState } from 'react';
import { RiRefundLine } from 'react-icons/ri';
import { Button } from '@chakra-ui/react';
import RefundFiatCreditModal from 'modules/credit-transactions/RefundFiatCreditModal';

const RfiRequestedActions = ({ transaction, refresh }) => {
  const [isRefundFiatCreditModal, setIsRefundFiatCreditModal] = useState(false);
  const handleOpenRefundTxnModal = (e) => {
    e.stopPropagation();
    setIsRefundFiatCreditModal(true);
  };

  return (
    <>
      <Button
        size='sm'
        variant='link'
        width='fit-content'
        onClick={handleOpenRefundTxnModal}
        leftIcon={<RiRefundLine size='15px' />}
      >
        Refund
      </Button>
      {isRefundFiatCreditModal && (
        <RefundFiatCreditModal
          isOpen={isRefundFiatCreditModal}
          onClose={() => setIsRefundFiatCreditModal(false)}
          transaction={transaction}
          refresh={refresh}
        />
      )}
    </>
  );
};

export default RfiRequestedActions;
